export const BORDER_COLOR = "#d2d2d0";
export const COL_ONE_WIDTH = 100;
